import { COUNTRIES } from "@common/countries";
import { CodeCombobox, type CodeComboboxProps } from "./CodeCombobox";

const COUNTRY_CODES = COUNTRIES.map((country) => country.code);

const countryName = (code: string) =>
    COUNTRIES.find((country) => country.code === code)?.name ?? code;

/** Searchable country picker; `value` is the country code or `null`. */
export const CountrySelect = ({
    buttonSize = "lg",
    ...props
}: CodeComboboxProps) => (
    <CodeCombobox
        {...props}
        buttonSize={buttonSize}
        codes={COUNTRY_CODES}
        codeLabel={countryName}
        placeholder="Select country..."
        searchPlaceholder="Search countries..."
        emptyText="No matching countries"
    />
);
